import { Typography } from "@mui/material";
import { StepperNavBackgroundWrapper } from "./user-header.style";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "../../../../../components/button/button";
import { EditIcon } from "../../../../../utils/svg-components";
import { useAuth } from "../../../../../context/AuthContext";
import { CircularIconButton } from "../../../../../components/circular-button/circular-button.styles";

const UserHeader = (props) => {
  const {
    isSaveEnabled,
    userDetails,
    activeTab,
    isEditMode,
    setIsEditMode,
    isSaving,
    handleSave,
  } = props;

  const { userPermissions } = useAuth();

  const navigate = useNavigate();

  return (
    <StepperNavBackgroundWrapper>
      <div className="flex">
        <CircularIconButton onClick={() => navigate("/admin-console")}>
          <ChevronLeft />
        </CircularIconButton>
        <div className="head-flex">
          <Typography variant="h5">
            {userDetails?.firstName} {userDetails?.surname}
          </Typography>
        </div>
      </div>
      <div>
        {activeTab === "basic-info" && (
          <div>
            {userPermissions !== "General" && !isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={() => setIsEditMode(true)}
                startIcon={<EditIcon />}
                sx={{ height: "33px" }}
              >
                Edit User
              </Button>
            )}

            {userPermissions !== "General" && isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={handleSave}
                startIcon={<EditIcon />}
                isLoading={isSaving}
                disabled={!isSaveEnabled}
              >
                Save User
              </Button>
            )}
          </div>
        )}
      </div>
    </StepperNavBackgroundWrapper>
  );
};

export default UserHeader;
